/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber7Small = createReactComponent("outline", "number-7-small", "IconNumber7Small", [["path", { "d": "M10 8h4l-2 8", "key": "svg-0" }]]);

export { IconNumber7Small as default };
//# sourceMappingURL=IconNumber7Small.mjs.map
